import { render, staticRenderFns } from "./ChatEmotionalRuler.vue?vue&type=template&id=3351518c&scoped=true"
import script from "./ChatEmotionalRuler.vue?vue&type=script&lang=js"
export * from "./ChatEmotionalRuler.vue?vue&type=script&lang=js"
import style0 from "./ChatEmotionalRuler.vue?vue&type=style&index=0&id=3351518c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3351518c",
  null
  
)

export default component.exports